import { GameSpeedInfoDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
export const showGameSpeedInfoDialog = mountDialogUIReactComponent(GameSpeedInfoDialog);
